import {
  Block,
  Settings,
  SettingSectionTitle,
  SettingsFlexbox
} from '@/components/DybrComponents/StyledServicePagesElements';
import { CrosspostBlock } from '@/scenes/User/Settings/CrosspostBlock';

const platforms = [
  // {
  //   id: 'diary',
  //   displayName: 'diary.ru'
  // },
  {
    id: 'dreamwidth',
    displayName: 'dreamwidth.org'
  },
  {
    id: 'livejournal',
    displayName: 'livejournal.com'
  }
];

export function CrosspostSettings() {
  return (
    <Block>
      <SettingsFlexbox>
        <SettingSectionTitle>
          <h4>Кросспост</h4>
          <p>
            Вы можете настроить автоматическое дублирование записей вашего блога
            на другие сервисы
          </p>
        </SettingSectionTitle>
        <Settings>
          {platforms.map(platform => (
            <CrosspostBlock key={platform.id} platform={platform} />
          ))}
        </Settings>
      </SettingsFlexbox>
    </Block>
  );
}
